import styled from "styled-components";
import { colors } from "../../helpers/functions";

export const HeaderProductStyled = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 100%;
    height: 400px;
    //background-image: url("../images/header_products.jpg");
    background-image: url(${props => "../images/"+props.header});
    background-size: cover;
    background-position: 50% 50%;
    .box_trebol{
        display: flex;
        flex-direction: row;
        position: absolute;
        justify-content: center;
        align-items: center;
        bottom: 5px;
        right: 5px;
        padding: 5px 10px 5px 8px;
        z-index: 9;
        background-color: rgba(0,0,0,0.8);
        color: ${colors.blanco_huevo};
        .trebol{
            width: 25px;
            img{
                float: left;
                width: 100%;
            }
        }
        .icon{
            display: flex;
            color: rgb(${colors.blanco_huevo});
            font-size: 20px;
            margin-left: 5px;
            .complete{
                color: green;
            }
            .pending{
                color: red;
            }
            svg{
                display: flex;
            }
        }
        .name{
            margin-left: 5px;
            color: #FFFFFF;
            font-size: 16px;
            font-weight: 600;
        }
    }
    .iso{
        width: calc(100% - 150px);
        max-width: 850px;
        img{
            float: left;
            width: 100%;
        }
    }
`